export class InvalidFieldNameError extends Error {
    constructor(componentName, fieldName) {
        super(`Cannot render ${componentName}. Unsupported field name: '${fieldName}'.`);
        this.componentName = componentName;
        this.fieldName = fieldName;
        Object.setPrototypeOf(this, InvalidFieldNameError.prototype);
    }
}
//# sourceMappingURL=invalid-field-name-error.js.map